import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! @glint-nocheck: not typesafe yet }}\n<div class={{@class}} ...attributes>{{yield}}</div>")